"use strict";
/**
 * mobx-task
 *
 * Copyright © Jeff Hansen 2017.
 * MIT licensed.
 */

module.exports.task = require('./task');